module.exports = __webpack_public_path__ + "static/media/forgot-password.eb280770.png";